export const BACKGROUND_FILTER_VIDEO_CONSTRAINTS: MediaStreamConstraints["video"] =
  {
    width: 640,
    height: 480,
    frameRate: 24,
  };

export const DEFAULT_VIDEO_CONSTRAINTS: MediaStreamConstraints["video"] = {
  width: 1280,
  height: 720,
  frameRate: 24,
};

// These are used to store the selected media devices in localStorage
export const SELECTED_AUDIO_INPUT_KEY = "TwilioVideoApp-selectedAudioInput";
export const SELECTED_AUDIO_OUTPUT_KEY = "TwilioVideoApp-selectedAudioOutput";
export const SELECTED_VIDEO_INPUT_KEY = "TwilioVideoApp-selectedVideoInput";

// This is used to store the current background settings in localStorage
export const SELECTED_BACKGROUND_SETTINGS_KEY =
  "TwilioVideoApp-selectedBackgroundSettings";

export const GALLERY_VIEW_ASPECT_RATIO = 9 / 16; // 16:9
export const GALLERY_VIEW_MARGIN = 3;

export const SESSION_TOKEN_COOKIE_NAME = "session";
export const GUEST_TOKEN_COOKIE_NAME = "guestToken";

// The number of minutes before a lesson start time that the user is allowed to join
export const LESSON_JOIN_GRACE_PERIOD = 5;

export const MAX_TIP = 20;

export const API_HOSTNAME = import.meta.env.VITE_PUBLIC_HOSTNAME;
export const TUTRED_CLIENT_HOSTNAME = import.meta.env
  .VITE_PUBLIC_TUTRED_CLIENT_HOSTNAME;
export const AI_SERVICE_HOSTNAME = import.meta.env
  .VITE_PUBLIC_AI_SERVICE_HOSTNAME;
